export default "__VITE_ASSET__B8q89mFM__"